import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { ConstantRoute } from '../constant-routing/constant-route';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ServicesService } from 'src/services/services.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  standalone: false
})
export class AdminComponent {
  mobileQuery: MediaQueryList;
  filteredMenus: any = [];
  menus: any = [];
  roles: string = '';

  private _mobileQueryListener: () => void;
  User: string | null;
  result: any;
  selectedValue: any;
  Event_Name: any;
  user_id: any;
  eventId: any;
  selectedValue_SO: any;
  isOwner = false;
  event_id: any;
  setting_data: any;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private router: Router,
    private dialog: MatDialog,
    private service: ServicesService,
    private toastr: ToastrService,
    private location: Location
  ) {
    this.menus = ConstantRoute.menus;
    this.User = sessionStorage.getItem('User');
    this.eventId = sessionStorage.getItem('Event_ID');


    if (this.User == 'superadmin' && this.eventId) {
      // Filter to show only admin-related menus
      this.filteredMenus = ConstantRoute.menus.filter((element: any) =>
        element.roles.includes('admin') && element.path !== 'Listings'
      );
    } else if (this.User == 'admin') {
      // If user is 'admin', show only admin-related menus
      this.filteredMenus = ConstantRoute.menus.filter((element: any) =>
        element.roles.includes('admin')
      );
    } else {
      this.filteredMenus = ConstantRoute.menus.filter((element: any) => {
        return element.roles.includes(this.User);
      });

    }

    this.mobileQuery = media.matchMedia('(max-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
    this.selectedValue = sessionStorage.getItem('Event_ID');
    this.selectedValue_SO = sessionStorage.getItem('SO_Event_ID');

    this.user_id = sessionStorage.getItem('User_ID');
    this.GetMyStall(this.user_id);
    this.getevent();
    if ((this.User == "admin" || this.User == "subadmin" || this.User == "stallowner") && !this.selectedValue) {
      this.openDialog();
    }
  }

  GetMyStall(user_id: any) {
    this.service.get_my_stall(user_id).subscribe(
      (data: any) => {
        this.isOwner = data.flag;

        console.log(this.isOwner);

        // 👇 After filtering, if My Stall was skipped, manually add it
        const ownerMenus = ['My Stall'];

        if (this.isOwner) {
          ownerMenus.forEach(menuPath => {
            if (!this.filteredMenus.find((m: any) => m.path === menuPath)) {
              const menuItem = ConstantRoute.menus.find((m: any) => m.path === menuPath);
              if (menuItem) {
                this.filteredMenus.push(menuItem);
              }
            }
          });
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  openDialog(): void {
    this.dialog.open(SelectEventComponent, {
      width: '400px',
    });
  }

  getevent() {

    if (this.selectedValue == 0 && this.selectedValue_SO != 0) {
      console.log("get_so_id");

    } else {
      this.service.get_event_by_id(this.selectedValue).subscribe(
        (data: any) => {
          this.result = data.data;
          this.Event_Name = this.result[0].event_name;
        });
    }

  }

  logout() {
    sessionStorage.clear();
    this.router.navigateByUrl('/admin-auth')
  }

  goToWebsite() {
    window.location.href = 'https://aieventzo.com/';
  }


  Registration_Form() {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.service.getsetting(this.event_id).subscribe(
      (data: any) => {
        this.setting_data = data.data;
        const baseUrl = this.setting_data[0].reg_url;
        window.open(baseUrl, "_blank");
      })
  }

  copyLink() {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.service.getsetting(this.event_id).subscribe(
      (data: any) => {
        this.setting_data = data.data;
        const baseUrl = this.setting_data[0].reg_url;
        navigator.clipboard.writeText(baseUrl).then(() => {
          this.toastr.success('Link copied to clipboard')
          // Optionally, provide feedback to the user
        }).catch(err => {
          console.error('Failed to copy link: ', err);
        });
      })

  }

  Registration_QR() {

    this.dialog.open(qrcodeComponent, {
      width: '400px',
    });
  }


  Superadmin() {
    sessionStorage.removeItem('Event_ID');
    this.router.navigateByUrl('/admin/Events');
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

}


@Component({
  selector: 'select-event',
  templateUrl: './select-event.html',
  standalone: false
})
export class SelectEventComponent {
  RoleForm: FormGroup;
  role_id: any;
  role: any;
  result: any;
  main: any;
  eventmain: any;
  selectedValue: any;
  Userid: any;

  constructor(
    private service: ServicesService,
    private formbuilder: FormBuilder,
    dialogRef: MatDialogRef<SelectEventComponent>,
  ) {
    dialogRef.disableClose = true;
    this.RoleForm = this.formbuilder.group({
      selectedValue: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.selectedValue = sessionStorage.getItem('Event_ID');
    this.RoleForm = new FormGroup({
      selectedValue: new FormControl(this.selectedValue)
    })
    this.Userid = sessionStorage.getItem('User_ID');
    this.getevent();
  }

  getevent() {
    this.service.get_event_by_user(this.Userid).subscribe((data: any) => {
      this.eventmain = data.data.filter((event: any) => event.is_active == "1");
      console.log(this.eventmain);
    });
  }

  onSkip() {
    console.log('Skip button clicked');
    sessionStorage.setItem('User', "user");
    sessionStorage.setItem('Event_ID', "0");
    sessionStorage.setItem('SO_Event_ID', "0");
    window.location.reload();

  }

  onFormSubmit() {
    if (!this.selectedValue || !this.selectedValue.event_id) {
      alert("Please select an event before submitting OR skip!");
      return;
    }

    console.log(this.selectedValue.event_id);

    if (sessionStorage.getItem('User') != "superadmin") {
      sessionStorage.setItem('User', this.selectedValue.role);
    }

    sessionStorage.setItem('Event_ID', this.selectedValue.event_id);
    sessionStorage.setItem('SO_Event_ID', this.selectedValue.so_event_id);
    window.location.reload();
  }




}

@Component({
  selector: 'qrcode',
  templateUrl: './qrcode.html',
  styleUrls: ['./admin.component.scss'],
  standalone: false
})
export class qrcodeComponent {
  event_id: any;
  qrData: any;
  setting_data: any;

  constructor(
    private service: ServicesService,
    dialogRef: MatDialogRef<qrcodeComponent>,
  ) {

  }

  // To hold references to all canvas elements
  @ViewChild('qrcodeCanvas') qrcodeCanvas: ElementRef | undefined; // Only one canvas
  ngOnInit() {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.Get_Setting(this.event_id);
  }

  Get_Setting(eventId: any) {
    this.service.getsetting(eventId).subscribe(
      (data: any) => {
        this.setting_data = data.data;
        this.qrData = this.setting_data[0].reg_url;
        console.log(this.qrData);
        this.generateQRCode();
      })
  }


  generateQRCode() {
    const canvasElement = this.qrcodeCanvas?.nativeElement as HTMLCanvasElement;

    if (canvasElement) {
      const size = 250; // High res → 800x800 px

      canvasElement.width = size;   // actual pixels
      canvasElement.height = size;

      QRCode.toCanvas(canvasElement, this.qrData, {
        width: size,     // render size
        margin: 2,
      }, (error) => {
        if (error) {
          console.error('Error generating QR code:', error);
        }
      });
    } else {
      console.error('Canvas element not found for QR code generation');
    }
  }

  // Download the QR code image from the canvas
  downloadQRCode() {
    const canvas = this.qrcodeCanvas?.nativeElement as HTMLCanvasElement;
    if (canvas) {
      const imageUrl = canvas.toDataURL("image/png", 1.0); // high quality
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = `qr-code-${Date.now()}.png`;
      link.click();
    }
  }

}


